const LAST_SEEN_QUOTE_PREFIX = 'last_seen_quote_date';

export function getTodayDateKey(now = new Date()): string {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getLastSeenQuoteStorageKey(consultantId: string): string {
    return `${LAST_SEEN_QUOTE_PREFIX}_${consultantId}`;
}

export function shouldShowQuoteBubble(consultantId: string, hasPhrase: boolean): boolean {
    if (!hasPhrase || typeof window === 'undefined') return false;
    const stored = localStorage.getItem(getLastSeenQuoteStorageKey(consultantId));
    return stored !== getTodayDateKey();
}

export function dismissQuoteBubbleForToday(consultantId: string): void {
    if (typeof window === 'undefined') return;
    localStorage.setItem(getLastSeenQuoteStorageKey(consultantId), getTodayDateKey());
}
